<div class="admin-container">
  <app-sidebar></app-sidebar>
  <main class="main-content">
    <app-header [pageTitle]="pageTitle"></app-header>
    <router-outlet></router-outlet>
  </main>
</div>
